var Popup = {

        init: function(){
        this.popup = app.popup.create({
            el: '.main-popup',
            on: {
                opened: function () {
                    Render.do($('.page-content', Popup.popup.el)[0]);
                    $(Popup.popup.el).find("script").each(function(el)
                    {
                        if ($(this).attr('src'))
                        {
                            var s = document.createElement('script');
                            s.src = $(this).attr('src');
                            $('head').append(s);
                        }
                        else
                        {
                            eval($(this).text());
                        }

                    });

                                    }
            }
        });

            },

        content: function(content){
        $('.navbar .title', this.popup.el).empty();
        if ($(content).find(".popup-title").length) {
            $('.navbar .title', this.popup.el).html($(content).find(".popup-title").text());
        }
        $('.page-content', this.popup.el).html(content);
    },

        open: function(){
        this.popup.open();
    },

        close: function(){
        this.popup.close();
    }
}

$("body").on("click", ".main-popup-open", function(){
    var selector = $(this).data("popup");
    if (selector && $(selector).length) {
        Popup.content($(selector).html());
        Popup.open();
    }
});

$("body").on("click", ".popup-trigger", function(){
    var action = $(this).data("action"),
        event = $(this).data("event");
    if (action) {
        app.request({
           url: action,
           method: 'GET',
           dataType: 'html',
           data: {
               _ : Date.now()
           },
           success: function (data) {
                var $html = $("<div>" + data + "</div>");
                if ($html.find('.page-content').length > 1) {
                    data = $html.find('.page-content').html();
                    $html = $("<div>" + data + "</div>");
                }
                Popup.content($html.children().length > 1 ? "<div>" + data + "</div>" : data);
                Popup.open();

                                if (event) {
                    Events.notify(event)
                }
           }
        });
   }

    })

Render.add("#alert", function(){
    app.dialog.alert($(".text", this).html(), $(".title", this).html());
})

